import { render, staticRenderFns } from "./CenterArea.vue?vue&type=template&id=69531ad2&scoped=true&"
import script from "./CenterArea.vue?vue&type=script&lang=js&"
export * from "./CenterArea.vue?vue&type=script&lang=js&"
import style0 from "./CenterArea.vue?vue&type=style&index=0&id=69531ad2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69531ad2",
  null
  
)

export default component.exports